var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.947 6.412 1.155-1.156c1.201-1.2 1.201-3.155 0-4.356a3.059 3.059 0 0 0-2.178-.9c-.823 0-1.597.32-2.178.9l-1.155 1.156 4.356 4.356Zm-5.36-3.35-8.562 8.56a1.663 1.663 0 0 0-.402.652L.036 17.069a.71.71 0 0 0 .899.898l4.793-1.588c.245-.08.47-.22.653-.402l8.56-8.56-4.355-4.356Z",
    fill: "#BFC3D1"
  })));
};

export default SvgPencil;